import Vue from 'vue'
import linkifyHtml from 'linkifyjs/html'

Vue.directive('linkify', {
    inserted(el) {
        el.innerHTML = linkifyHtml(el.innerText)
    },
})
